/* ========================================================================= *
 * TradeChip — the trade status ON a Command Center row, inline.
 *
 * Renders nothing when the record is under no trade (most rows), so a 400-row
 * board is not padded with "no trade" noise. When it IS under one, the chip
 * names the state and who, and is itself the door: an active desk offer opens
 * its card on the Trade Desk; a flagged trade opens the control that fixes it.
 *
 * ⚠️ IT STOPS THE CLICK. Every row it sits on opens the record drawer on tap,
 * and a chip that also opened the drawer would be a control that does
 * something other than what it says.
 * ========================================================================= */
import { Link } from 'react-router-dom'
import { useTradeLinks } from '../../lib/useTradeLinks.js'
import { tradesOnRecord, chipFor } from '../../lib/tradeLinks.js'
import styles from './Trades.module.css'

const stop = (e) => e.stopPropagation()

export default function TradeChip({ recordId }) {
  const { links } = useTradeLinks()
  if (!links || !recordId) return null
  const chip = chipFor(tradesOnRecord(links, recordId))
  if (!chip) return null
  return (
    <span className={styles.chipWrap} onClick={stop}>
      <Link className={styles.chip} data-tone={chip.tone} to={chip.to} title={chip.title}
        aria-label={`Trade: ${chip.label}`}>
        ⇄ {chip.label}
      </Link>
      {chip.fix?.to ? (
        <Link className={styles.chip} data-tone="bad" to={chip.fix.to} title={chip.fix.why}>
          Fix: {chip.fix.label}
        </Link>
      ) : null}
    </span>
  )
}
